// import App from '../app/App'
// import Home from '../view/home/Index'
import Login from '../view/Login/login';
// import Portal from '../view/Portal/portal'
// import Logout from '../view/logout'

// import asyncComponent from './asyncComponent'

// const Login = asyncComponent(()=>import('../view/Login/login'))
// const Portal = asyncComponent(()=>import('../view/Portal/portal'))

/**
 * @description frameRouter[0] 显示在侧边栏，如果有不想显示在侧边栏的路由，放在frameRouter[n]
 */
const frameRouter = [
  {
    path: '/login',
    component: Login,
  },
  // {
  //     path: '/portal',
  //     component : Portal
  // },
  // {
  //     path: '/logout',
  //     component : Logout
  // }
];

export default frameRouter;



// WEBPACK FOOTER //
// ./src/routers/frameRouter.js